import { FunctionComponent } from 'react';
import { useRouter } from 'next/router';
import { ConfirmationOverlay } from '@havenengineering/module-shared-owners-ui';

import styles from './RenewalModal.module.scss';

export const RenewalModal: FunctionComponent<{
  isOpen: boolean;
  renewalYear: number;
  handleCancelClick?: () => void;
}> = ({ isOpen, renewalYear, handleCancelClick }) => {
  const router = useRouter();

  return (
    <ConfirmationOverlay
      isOpen={isOpen}
      title="It's time to renew for next year"
      content={
        <div className={styles.content}>
          <img src="/assets/house.svg" alt="" width="110" />
          <p>
            Renew with Let2offset for {renewalYear} to add your preferred break
            dates and confirm your selection.
          </p>

          <div className={styles.greyLine} />

          <div className={styles.timeEstimate}>
            <img src="/assets/icon-clock.svg" alt="" />
            <b>Around 30 minutes</b>
          </div>

          <p>Breaks are reserved for 2 hours.</p>
        </div>
      }
      handleOk={() => router.push('/renewals')}
      handleCancel={() => handleCancelClick?.()}
      okLabel="Renew now"
    />
  );
};
